/*
  src/redux/notifications/reducer.js

  Created by erikchristensen on 11/22/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import { NOTIFICATION_SHOWN, NOTIFICATION_DISMISSED } from './constants';
import update from 'immutability-helper';

const initialState = [];

export default function(state=initialState,action){
  switch(action.type){
  case NOTIFICATION_DISMISSED:
    return update(state,{
      $apply:(array) => array.filter((i) => i.id !== action.payload.id)
    });

  case NOTIFICATION_SHOWN:
    return update(state,{
      $push:[action.payload]
    });

  default:
    return update(state,{});
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/notifications/reducer.js